import { render, staticRenderFns } from "./EntityBadgeSet.vue?vue&type=template&id=136300b6&scoped=true&"
import script from "./EntityBadgeSet.vue?vue&type=script&lang=js&"
export * from "./EntityBadgeSet.vue?vue&type=script&lang=js&"
import style0 from "./EntityBadgeSet.vue?vue&type=style&index=0&id=136300b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136300b6",
  null
  
)

export default component.exports